// src/services/uploadHistory.ts
import axios from 'axios'
import { getTokenConfig } from '../../../../../src/auth'

export interface BulkHistoryRow {
  id: number
  documentName: string
  documentUrl: string
  userId: string
  userName: string
  status: 'success' | 'failed'
  uploadType: 'recharges' | 'payment_services'
  createdAt: string
}

export interface FetchHistoryParams {
  page?: number
  limit?: number
  startDate?: string
  endDate?: string
  uploadType?: 'recharges' | 'payment_services'
}

const API_URL = process.env.REACT_APP_API_URL

export const fetchBulkUploadHistory = async (params: FetchHistoryParams) => {
  const config = await getTokenConfig()
  const resp = await axios.get(
    `${API_URL}/bulk-upload/history`,
    {
      ...config,
      params
    }
  )
  return resp.data as {
    items: BulkHistoryRow[]
    total: number
    page: number
    pages: number
  }
}
